export const appActionArgumentType = {
  key: 'appActionArgumentType',
  type: 'app',
  label: 'Argument Type',
  description: 'Suggests if this should be a list based on other actions and the relevant API documentation.',
  path: 'actions[id:{{actionId}}].arguments[id:{{argumentId}}].dataType',
  shouldRun: ({ changes }) => {
    return changes?.some((change) => change?.path?.includes('arguments') && change?.path?.endsWith('dataType') && change?.value !== 'list');
  },
  context: ['actionDocs', 'argumentId'],
  mapContext: ({ app, action, actionDocs, argumentId }) => {
    return {
      argument: action?.arguments?.find((arg) => arg?.id === argumentId),
      actionName: action?.name,
      actionModel: action?.model,
      actionDescription: action?.description,
      actionOperation: action?.operation || 'none',
      actionSlug: action?.slug,
      appName: app?.name,
      actions: app?.actions,
      actionDocs
    };
  },
  prompt: 'appActionArgumentType'
};
